import classNames from "classnames";
import AscCircularProgressBar from "../AscCircularProgressBar/AscCircularProgressBar";
import styles from "./AscStudentsInfoBlock.module.scss";

export interface AscStudentsInfoBlockProps {
  className?: string;
  title: string;
  text: string;
  percentage: number;
  color: string;
}

export default function AscStudentsInfoBlock({
  className,
  title,
  text,
  percentage,
  color,
}: AscStudentsInfoBlockProps) {
  return (
    <div
      data-testid="asc-sutdents-info-block"
      className={classNames(styles.ground, className)}
    >
      <div className={styles.progressBar}>
        <AscCircularProgressBar percentage={percentage} color={color} />
      </div>
      <span className={styles.title}>{title}</span>
      <span className={styles.text}>{text}</span>
    </div>
  );
}
